import { Button, Dialog, Stack, Text } from "@mantine/core";
import { FC, useEffect, useRef } from "react";
import { AiTaskStatus, JobRecommendTaskDTO } from "../models/Message";
import { ChatSession } from "../models/ChatSession";

interface JobRecTaskCompleteDialogProps {
  opened: boolean;
  onClose: () => void;
  jobRecommendTaskStatus: JobRecommendTaskDTO | null;
  switchActiveSession: (
    newSession: ChatSession | null,
    isNewlyTakenOver: boolean,
  ) => void;
  chatSession: ChatSession;
}

const JobRecTaskCompleteDialog: FC<JobRecTaskCompleteDialogProps> = ({
  opened,
  onClose,
  jobRecommendTaskStatus,
  switchActiveSession,
  chatSession,
}) => {
  // Capture jobRecommendTaskStatus task at time of opening
  const initialTextRef = useRef<string>();

  useEffect(() => {
    if (opened && !initialTextRef.current) {
      const statsMsg = jobRecommendTaskStatus?.status === AiTaskStatus.DONE 
      ? 'complete.' : 'failed!';
      initialTextRef.current = `${jobRecommendTaskStatus?.jobTitle} at ${jobRecommendTaskStatus?.location} is ${statsMsg}`;
    }
  }, [opened, jobRecommendTaskStatus]);

  return (
    jobRecommendTaskStatus && (
      <Dialog
        position={{ top: 20, right: 20 }}
        opened={opened}
        withCloseButton
        onClose={onClose}
      >
        <Stack>
          <Text mt="md">
            AI job recommendation task for {initialTextRef.current}
          </Text>
          <Button
            onClick={() => {
              switchActiveSession(chatSession, false);
              onClose();
            }}
          >
            Go to this chat session
          </Button>
        </Stack>
      </Dialog>
    )
  );
};

export default JobRecTaskCompleteDialog;
